export default __webpack_public_path__ + "static/media/icon-review.508c599b.svg";